import Vue from 'vue'
import VueRouter from 'vue-router'

// Routes
import {canNavigate} from '@/libs/acl/routeProtection'
import {isUserLoggedIn, getUserData, getHomeRouteForLoggedInUser} from '@/auth/utils'
import {
    APPLICATION_TRANSLATION_GROUP,
    loadTranslationGroups,
} from '@/libs/i18n'
import pages from './routes/pages'
import product from './routes/product'
import requests from './routes/requests'
import system from './routes/system'
import statistics from './routes/statistics'
import administration from "@/router/routes/administration";
import internalTools from './routes/internalTools'

Vue.use(VueRouter)

const router = new VueRouter({
    mode: 'history',
    base: process.env.APP_BASE_URL,
    scrollBehavior() {
        return {x: 0, y: 0}
    },
    routes: [
        {path: '/', redirect: {name: 'homepage'}},
        ...pages,
        ...product,
        ...requests,
        ...administration,
        ...system,
        ...internalTools,
        ...statistics,
        {
            path: '*',
            redirect: 'error-404',
        },
    ],
})

router.beforeEach((to, _, next) => {
    const isLoggedIn = isUserLoggedIn()

    if (!canNavigate(to)) {
        // Redirect to login if not logged in
        if (!isLoggedIn) {
            return next({name: 'auth-login'})
        }
        // If logged in => not authorized
        return next({name: 'not-authorized'})
    }

    // Redirect if logged in
    if (to.meta.redirectIfLoggedIn && isLoggedIn) {
        const userData = getUserData()

        return next(getHomeRouteForLoggedInUser('admin'))
    }

    const translationGroups = Object.prototype.hasOwnProperty.call(to.meta, 'translationGroups')
        ? to.meta.translationGroups
        : (to.meta.layout === 'full' && to.meta.resource === 'Auth'
            ? []
            : [APPLICATION_TRANSLATION_GROUP])

    return loadTranslationGroups(translationGroups)
        .then(() => next())
        .catch(() => next())
})

// ? For splash screen
// Remove afterEach hook if you are not using splash screen
router.afterEach(() => {
    // Remove initial loading
    const appLoading = document.getElementById('loading-bg')
    if (appLoading) {
        appLoading.style.display = 'none'
    }
})

export default router
